// extracted by mini-css-extract-plugin
export default {"chip":"Chip_chip__zdxID","chip__success":"Chip_chip__success__IDgVB","chip__warning":"Chip_chip__warning__lrqrY"};